import React from "react";
import ReactSelect from "react-select";
import * as CustomSelectorComponents from "./CustomSelectorComponents";

class BuddySelector extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		const { children, options, onChange, ...rest } = this.props;

		if (children) {
			console.warn("Class: BuddySelector should not receive any children, provided children are not being used");
        }

		return (
			<ReactSelect
                {...rest}
				components={CustomSelectorComponents}
                options={options}
				onChange={onChange}
			/>
		);
	}
}

export default BuddySelector;